module.exports = __webpack_public_path__ + "images/_/programs/keepCool/images/level-2_start-7d69e5f0039ee3aa45c51956ec7606cc.png";


//////////////////
// WEBPACK FOOTER
// ./programs/keepCool/images/level-2_start.png
// module id = 441
// module chunks = 2